<div class="card mt-3">
  <div class="card-body">
    <h3 class="mb-4">{{ 'MENU.DASHBOARD.edit_employee' | translate }} </h3>

    <form (ngSubmit)="updateEmployee()" enctype="multipart/form-data" #editForm="ngForm">
      <!-- Image Upload -->
      <div class="row">
        <div class="col-6">
        <div class="form-group">
          <div class="file-upload-container">
            <input type="file" id="logoUpload" accept="image/*" (change)="onFileSelected($event)" #imageInput>
            <div class="file-upload-label">
              <i class="fas fa-cloud-upload-alt file-upload-icon"></i>
              <div class="file-upload-text">{{ 'MENU.DASHBOARD.click_to_upload_imageEmp' | translate }}</div>
              <div class="file-upload-text"> {{ 'MENU.DASHBOARD.drag_drop_image' | translate }}</div>
              <div class="form-hint">{{ 'MENU.DASHBOARD.recommended_size' | translate }}</div>
            </div>
          </div>
          <!-- Image validation message -->
          <div *ngIf="imageInput.touched && !product.image" class="text-danger small mt-1">
            {{ 'VALIDATION.image_required' | translate }}
          </div>
          <!-- رسالة إذا مافيش صورة -->
          <div class="no-preview" *ngIf="!product.image">
            <div class="form-hint"> {{ 'MENU.DASHBOARD.no_imageEmp_uploaded' | translate }}</div>
          </div>
        </div>
        </div> 
        <!-- معاينة الصورة -->
        <div class="col-6">
          <div class="image-preview-container" *ngIf="product.image">
            <div class="image-preview-header">
              <h6>{{ 'MENU.DASHBOARD.image_preview' | translate }}</h6>
              <button type="button" class="btn-close" (click)="removeImage()" aria-label="Close"></button>
            </div>
            <div class="image-preview">
              <img [src]="product.image" alt="Preview" class="preview-image">
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- Name -->
        <div class="col-sm-4">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.name' | translate }}</label>
            <input
              type="text"
              class="form-control"
              [class.is-invalid]="name.invalid && name.touched"
              placeholder="{{ 'MENU.DASHBOARD.enter_name' | translate }}"
              [(ngModel)]="product.name"
              name="name"
              #name="ngModel"
              required
              minlength="2"
              maxlength="50"
            />
            <div *ngIf="name.invalid && name.touched" class="text-danger small mt-1">
              <div *ngIf="name.errors?.['required']">{{ 'MENU.DASHBOARD.name_required' | translate }}</div>
              <div *ngIf="name.errors?.['minlength']">{{ 'MENU.DASHBOARD.name_min_length' | translate }}</div>
            </div>
          </div>
        </div>

        <!-- Email -->
        <div class="col-sm-4">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.email' | translate }}</label>
            <input
              type="email"
              class="form-control"
              [class.is-invalid]="email.invalid && email.touched"
              placeholder="{{ 'MENU.DASHBOARD.enter_email' | translate }}"
              [(ngModel)]="product.email"
              name="email"
              #email="ngModel"
              required
              email
            />
            <div *ngIf="email.invalid && email.touched" class="text-danger small mt-1">
              <div *ngIf="email.errors?.['required']">{{ 'MENU.DASHBOARD.email_required' | translate }}</div>
              <div *ngIf="email.errors?.['email']">{{ 'MENU.DASHBOARD.email_invalid' | translate }}</div>
            </div>
          </div>
        </div>

        <!-- Phone -->
        <div class="col-sm-4">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.phone' | translate }}</label>
            <input
              type="text"
              class="form-control"
              [class.is-invalid]="phone.invalid && phone.touched"
              placeholder="{{ 'MENU.DASHBOARD.enter_phone' | translate }}"
              [(ngModel)]="product.phone"
              name="phone"
              #phone="ngModel"
              required
              pattern="^(05[0-9]{8}|5[0-9]{8}|9665[0-9]{8}|009665[0-9]{8}|\+9665[0-9]{8})$"
              maxlength="14"
            />
            <div *ngIf="phone.invalid && phone.touched" class="text-danger small mt-1">
              <div *ngIf="phone.errors?.['required']">{{ 'MENU.DASHBOARD.phone_required' | translate }}</div>
              <div *ngIf="phone.errors?.['pattern']">{{ 'MENU.DASHBOARD.saudi_phone_only' | translate }}</div>
            </div>
            <!-- تلميحات بالأشكال المقبولة -->
            <div class="form-text text-muted">
              <small>الأشكال المقبولة: 05XXXXXXXX, 5XXXXXXXX, 9665XXXXXXXX</small>
            </div>
          </div>
        </div>

        <!-- ID number -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.id_number' | translate }}</label>
            <input
              type="text"
              class="form-control"
              [class.is-invalid]="identity_number.invalid && identity_number.touched"
              placeholder="{{ 'MENU.DASHBOARD.id_number' | translate }}"
              [(ngModel)]="product.identity_number"
              name="identity_number"
              #identity_number="ngModel"
              required
              pattern="^[0-9]{10}$"
              maxlength="10"
            />
            <div *ngIf="identity_number.invalid && identity_number.touched" class="text-danger small mt-1">
              <div *ngIf="identity_number.errors?.['required']">{{ 'MENU.VALIDATION.id_number_required' | translate }}</div>
              <div *ngIf="identity_number.errors?.['pattern']">{{ 'MENU.VALIDATION.id_number_format' | translate }}</div>
            </div>
          </div>
        </div>

        <!-- Nationality -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.nationality' | translate }}</label>
            <select
              class="form-control"
              [class.is-invalid]="nationality_id.invalid && nationality_id.touched"
              [(ngModel)]="product.nationality_id"
              name="nationality_id"
              #nationality_id="ngModel"
              (change)="onNationalityChange()"
              required
            >
              <option value="" disabled>
                {{ 'MENU.DASHBOARD.select_countries' | translate }}
              </option>
              <option *ngFor="let country of countries" [value]="country.id" >
                {{ country.name }}
              </option>
            </select>
            <div *ngIf="nationality_id.invalid && nationality_id.touched" class="text-danger small mt-1">
              <div *ngIf="nationality_id.errors?.['required']">{{ 'MENU.DASHBOARD.nationality_required' | translate }}</div>
            </div>
          </div>
      </div>

      <div class="row">
       <!-- City -->
       <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.city' | translate }}</label>
            <select
              class="form-control"
              [class.is-invalid]="city_id.invalid && city_id.touched"
              [(ngModel)]="product.city_id"
              name="city_id"
              #city_id="ngModel"
              required
            >
              <option value="" disabled>{{ 'MENU.DASHBOARD.select_city' | translate }}</option>
              <option *ngFor="let city of cities" [value]="city.id" >
                {{ city.name }}
              </option>
            </select>
            <div *ngIf="city_id.invalid && city_id.touched" class="text-danger small mt-1">
              {{ 'MENU.VALIDATION.city_required' | translate }}
            </div>
            <div *ngIf="product.nationality && cities.length === 0" class="text-info small mt-1">
              {{ 'MENU.DASHBOARD.loadin' | translate }}
            </div>
            <!-- <div *ngIf="!product.nationality" class="text-info small mt-1">
              {{ 'MENU.DASHBOARD.select_nationality_first' | translate }}
            </div> -->
          </div>
        </div>

        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label required-field">
              {{ 'MENU.DASHBOARD.job_title' | translate }}
            </label>

            <select
              class="form-control"
              [class.is-invalid]="job_title_id.invalid && job_title_id.touched"
              [(ngModel)]="product.job_title_id"
              name="job_title_id"
              #job_title_id="ngModel"
              required
            >
              <option value="" disabled selected>
                {{ 'MENU.DASHBOARD.select_job_title' | translate }}
              </option>
              <option *ngFor="let title of jobTitles" [value]="title.id">
                {{title.name }}
              </option>
            </select>

            <!-- Validation Messages -->
            <div *ngIf="job_title_id.invalid && job_title_id.touched" class="text-danger small mt-1">
              <div *ngIf="job_title_id.errors?.['required']">
                {{ 'MENU.DASHBOARD.job_title_required' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Submit -->
      <div class="text-start mt-3">
        <button 
          type="submit" 
          class="btn px-4" 
          style="background-color: #cca44c !important; color: #fff;"
          [disabled]="editForm.invalid || isLoading"
        >
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
          {{ 'MENU.DASHBOARD.save_changes' | translate }}
        </button>
        
        <button 
          type="button" 
          class="btn btn-secondary ms-2 px-4 mx-2"
          (click)="cancel()"
          [disabled]="isLoading"
        >
          {{ 'MENU.DASHBOARD.cancel' | translate }}
        </button>
      </div>

      </div>
    </form>
  </div>
</div>